import { Fragment } from 'react';
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import Piechart from "../charts/Piechart";
import Barchart from "../charts/Barchart";

function Followers({ follower_profile }) {
    const { t } = useTranslation();

    return (
        <Fragment>
            <div className="card mt-5 mb-5 mb-xl-10">
                <div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#kt_account_profile_details" aria-expanded="true" aria-controls="kt_account_profile_details">
                    <div className="card-title m-0">
                        <h3 className="fw-bold m-0">{t("Followers")}</h3>
                    </div>
                </div>
                <div className="card-body">
                    <div className="d-flex mt-10">
                        <div className="d-flex col-3">
                            <Piechart follower_profile_ages={follower_profile?.ages} />
                        </div>
                        <div className="d-flex col-3">
                            <Piechart follower_profile_genders={follower_profile?.genders} />
                        </div>
                        <div className="d-flex col-6">
                            <Barchart follower_profile_location={follower_profile?.location} />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Followers);